/*
  NOTE: THIS IS A TEMPORARY SOLUTION TO ALLOW FOLLOWING ON THE PROFILE PAGE
  UNTIL WE ARE ABLE TO IMPLEMENT THE NEW PROFILE EXPERIENCE. USING THIS COMPONENT WILL
  REQUIRE RUNNING THE APPLICATION WITH SSL IN DEVELOPMENT.
*/

import Button from '@alltrails/shared/denali/components/Button';
import classNames from 'classnames';
import { UserConnection, UserConnectionActionType } from '@alltrails/shared/types/belay';
import { IdKey } from '@alltrails/shared/types/lists';
import { RequestState } from '@alltrails/shared/types/blazes';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import onUserActionClick from 'utils/community/userAction';
import COMMUNITY_CONNECT from '../communityConnectStrings.string';

type Props = {
  userConnection?: UserConnection;
  takeUserAction: (userActionKey: UserConnectionActionType) => void;
  className?: string;
  userId: IdKey;
};

const FollowButton = ({ userConnection, takeUserAction, className, userId }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { FOLLOW, FOLLOW_BACK, UNFOLLOW, REQUESTED }
  } = useFormatMessage(COMMUNITY_CONNECT);

  if (!userConnection || !userConnection.actions) {
    return <></>;
  }

  const { followBack, follow, unfollow, retractRequest } = userConnection.actions;
  const getTitle = () => {
    if (followBack) return FOLLOW_BACK;
    if (follow) return FOLLOW;
    if (unfollow) return UNFOLLOW;
    return REQUESTED;
  };
  const title = getTitle();
  const { requestState } = followBack || follow || unfollow || retractRequest || {};
  const props = { loading: requestState === RequestState.Loading, className: classNames(className), text: title, testId: title };

  if (followBack || follow) {
    const actionType = followBack ? UserConnectionActionType.FollowBack : UserConnectionActionType.Follow;
    return (
      <Button {...props} onClick={() => onUserActionClick(actionType, userId, userConnection.user.id, takeUserAction)} size="sm" variant="primary" />
    );
  }

  if (unfollow || retractRequest) {
    const actionType = unfollow ? UserConnectionActionType.Unfollow : UserConnectionActionType.RetractRequest;
    return (
      <Button {...props} onClick={() => onUserActionClick(actionType, userId, userConnection.user.id, takeUserAction)} size="sm" variant="default" />
    );
  }

  return <></>;
};

export default FollowButton;
